import styled from 'styled-components'
import { animated } from '@react-spring/web'
import { NotificationType } from '../../store/features/notificationsSlice'

export const Main = styled.div`
  cursor: pointer;
  color: #676767;
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
`

export const Container = styled.div`
  position: fixed;
  z-index: 1000;
  width: 0 auto;
  bottom: 30px;
  margin: 0 auto;
  left: 30px;
  right: 30px;
  display: flex;
  flex-direction: column;
  pointer-events: none;
  align-items: flex-end;
  @media (max-width: 680px) {
    align-items: center;
  }
`

export const Message = styled(animated.div)`
  box-sizing: border-box;
  position: relative;
  text-align: left;
  overflow: hidden;
  width: 40ch;
  @media (max-width: 680px) {
    width: 100%;
  }
`

export const Content = styled.div<{ type: NotificationType }>`
  color: black;
  background: white;
  padding: 18px 15px;
  font-size: 1em;
  display: flex;
border: 2px solid ${({ type }) => type === NotificationType.ERROR ? 'red' : 'rgba(36,159,61,1)'};
  gap: 2px;
  overflow: hidden;
  height: fit-content;
  border-radius: 8px;
  margin-top: 10px;
`

export const Button = styled.button`
  cursor: pointer;
  pointer-events: all;
  outline: 0;
  border: none;
  background: transparent;
  display: flex;
  align-self: flex-end;
  overflow: hidden;
  margin: 0;
  padding: 0;
  padding-bottom: 14px;
  color: black;
  :hover {
    color: red;
  }
`

export const Life = styled(animated.div)`
  position: absolute;
  bottom: 0;
  left: 0px;
  width: auto;
  background-image: linear-gradient(130deg, rgba(17,84,24,1) 0%, rgba(36,159,61,1) 35%, rgba(25,213,11,1) 100%);
  height: 3px;
`

export const LifeError = styled(Life)`
    background-image: linear-gradient(130deg, rgba(84,17,17,1) 0%, rgba(159,36,36,1) 35%, rgba(213,11,11,1) 100%);
`